import { Reveal } from "./Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "Natural Language as the Ultimate Compiler",
    body: "Traditional no-code traps you in proprietary sandbox silos. Emergent compiles high-level conversational intent straight into uncompromised, production-grade clean code.",
  },
  {
    number: "02",
    title: "Bicameral Full-Stack Generation",
    body: "Not just UI mockups. Emergent synthesizes concurrent frontend state machines, relational and document schemas, transactional payment hooks, and serverless compute in lockstep.",
  },
  {
    number: "03",
    title: "Zero Lock-in Sovereignty",
    body: "Download full Git repositories anytime. Deploy on Emergent's instant serverless edge, or self-host onto AWS, GCP, or your internal Kubernetes cluster with zero friction.",
  },
];

export const Manifesto = () => (
  <section id="manifesto" className="scroll-mt-24 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#2563eb]">01 // The Manifesto</p>
        <h2 className="font-display mt-6 max-w-2xl text-2xl font-semibold leading-[1.15] text-[#0b0f1a] sm:text-3xl lg:text-4xl">
          Three laws of the <span className="text-[#2563eb]">spoken build</span>.
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-6 md:grid-cols-3">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.number} delay={i * 0.12} className="h-full">
            <article
              data-testid={`manifesto-chapter-${c.number}`}
              className="card-soft card-lift group flex h-full flex-col rounded-3xl p-8 sm:p-10"
            >
              <span className="font-display text-6xl font-bold text-[#e8e8e4] transition-colors duration-500 group-hover:text-[#2563eb]">
                {c.number}
              </span>
              <h3 className="font-display mt-8 text-xl font-semibold text-[#0b0f1a] sm:text-2xl">{c.title}</h3>
              <p className="mt-4 text-sm leading-relaxed text-slate-500 sm:text-base">{c.body}</p>
              <span className="mt-auto block pt-8">
                <span className="block h-1 w-10 rounded-full bg-[#2563eb] transition-all duration-500 group-hover:w-full" />
              </span>
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
